import React from "react";
import useApiFetchInfinite from "src/Hooks/Shared/useApiFetchInfinite";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import InfiniteScroll from "react-infinite-scroll-component";
import useAuth from "src/Hooks/Custom/useAuth";
import VisibilityToggle from "src/Components/Shared/VisibilityToggle/VisibilityToggle";
import Group from "../Group/Group";
import useLoading from "src/Hooks/Custom/useLoading";
import { useTranslation } from "react-i18next";

type GroupProps = {
  endPoint: string,
  setGroupData?: any,
  refechForParent?: any,
  setModalVisibility?: any,
  search?: string
}

function GroupsToJoin({ endPoint, setGroupData, refechForParent, setModalVisibility, search }: GroupProps) {
  const { t, i18n } = useTranslation();
  const { user } = AppStateHandler.getState();
  const { loading } = useAuth();
  const { data, refetch, status, fetchMore } = useApiFetchInfinite(
    [
      search ? `${endPoint}?subId=${user?.username}&search=${search}` : `${endPoint}?subId=${user?.username}`
    ],
    {
      getFetchMore: (lastData) => {
        const nextPage = lastData?.data?.Page;
        const totalPages = lastData?.data?.TotalPages;

        return parseInt(nextPage ?? "1", 10) < totalPages
          ? `&page=${parseInt(nextPage ?? "1", 10) + 1}`
          : null;
      },
    }
  );
  useLoading(status);

  if (typeof refechForParent === 'function') {
    refechForParent(refetch);
  }

  if (data?.length === 0 && status === "loading") {
    return (
      <VisibilityToggle visible={loading}>
        <span className="spinner-border spinner-border-lg"></span>
        &nbsp;
      </VisibilityToggle>
    );
  }

  const arrayData = (Array.isArray(data) ? data : [])
    .map((_) => _.data.Items)
    .reduce((a, b) => a.concat(b), []);

  return (
    <>
      <VisibilityToggle visible={arrayData.length !== 0}>
        <h3 className={`fz16 mb-3 ${i18n.dir()==='rtl'?'text-right':''}`}>{t('Nearby Groups')}</h3>
      </VisibilityToggle>
      <InfiniteScroll
        dataLength={arrayData.length} //This is important field to render the next data
        next={fetchMore}
        hasMore={true}
        loader={
          <VisibilityToggle visible={loading}>
            <span className="spinner-border spinner-border-lg"></span>
          &nbsp;
        </VisibilityToggle>
        }
        endMessage={
          <p className="text-center">
            <b>Yay! You have seen it all</b>
          </p>
        }
        // below props only if you need pull down functionality
        refreshFunction={refetch}
        pullDownToRefresh
        pullDownToRefreshThreshold={50}
        pullDownToRefreshContent={
          <h3 className="text-center">&#8595; Pull down to refresh</h3>
        }
        releaseToRefreshContent={
          <h3 className="text-center">&#8593; Release to refresh</h3>
        }
      >
        {arrayData.map((item: any, index: number) => (
          <Group
            key={index}
            {...item}
            refetch={refetch}
            setGroupData={setGroupData}
            setModalVisibility={setModalVisibility}
          />
        ))}
      </InfiniteScroll >
    </>
  );
}

export default GroupsToJoin;
